import {useState} from 'react';
import {ResponsiveTable} from '../ui/ResponsiveTable';
import {formatDateOnly} from '../dates';
type Quote=Record<string,any>;
const money=(value:unknown)=>value===null||value===undefined||value===''||!Number.isFinite(Number(value))?'Not recorded':new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number(value));
export function QuoteComparison({quotes}:{quotes:Quote[]}){
 const [page,setPage]=useState(0),current=quotes.filter(row=>row.status!=='Superseded'),last=Math.max(0,Math.ceil(current.length/3)-1),index=Math.min(page,last),visible=current.slice(index*3,index*3+3);
 const criteria:[string,(quote:Quote)=>unknown][]=[['Scope',row=>row.scope_text],
 ['Net price',row=>money(row.price_net)],
 ['VAT',row=>money(row.tax_amount)],
 ['Gross price',row=>money(row.gross)],
 ['Exclusions',row=>row.exclusions],
 ['Earliest attendance',row=>formatDateOnly(row.proposed_start_date,'Not recorded')],
 ['Availability',row=>row.programme_text],
 ['Duration',row=>row.duration_text],
 ['Warranty',row=>row.warranty_text],
 ['Expiry',row=>formatDateOnly(row.validity_until,'Not recorded')],
 ['Evidence',row=>row.documents?.length?row.documents.map((document:Quote)=>document.title).join(' · '):'No documents returned'],
 ['Comparable basis',row=>row.comparability_reason],
 ['Review',row=>row.review_status],
 ['Recorded response',row=>row.status]];
 if(!current.length)return <p>No current quotations are recorded. Original responses and their review controls remain below.</p>;
 return <section className="quote-source-comparison" aria-label="Side-by-side quotation comparison">
<ResponsiveTable className="maintenance-comparison">
<caption>
<span className="sr-only">Supplier quotations compared against the same recorded criteria</span>
</caption>
<thead>
<tr>
<th scope="col">Comparison criteria</th>{visible.map(row=>
<th scope="col" key={row.id}>{row.contractor_name}<small>{row.provider_reference}</small>
</th>)}</tr>
</thead>
<tbody>{criteria.map(([label,value])=>
<tr key={label}>
<th scope="row">{label}</th>{visible.map(row=>
<td key={row.id}>{String(value(row)??'').trim()||'Not recorded'}</td>)}</tr>)}</tbody>
</ResponsiveTable>{last>0&&<nav aria-label="Quotation comparison pages">
<button className="secondary" disabled={index===0} onClick={()=>setPage(index-1)}>Previous suppliers</button>
<span>{index*3+1}–{Math.min(index*3+3,current.length)} of {current.length} quotations</span>
<button className="secondary" disabled={index===last} onClick={()=>setPage(index+1)}>Next suppliers</button>
</nav>}<p className="workspace-source-note">A recorded price or completeness review does not authorise an order. Review authority and the original evidence before making the separate approval decision.</p>
</section>;
}
